import style from "./RouteFallback.module.scss";

const RouteFallback = () => (
  <div className={style.fallback}>
    <div className={style.spinner} />
  </div>
);

export default RouteFallback;
